import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedService } from '@shared/service/sharedservice';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {
  roles: { name: string; isActive: boolean }[] = [];
  activeRole: string = '';
  isDisplayedInLayout: boolean = false;
  hideLayout: boolean = false;
  private roleSubscription!: Subscription;

  constructor(private sharedService: SharedService, private router: Router) {}

  ngOnInit(): void {
    const storedActiveRole = localStorage.getItem('activeRole');
    if (storedActiveRole) {
      this.activeRole = storedActiveRole;
    } else {
      this.setDefaultRole();
    }

    this.loadUserRoles();

    this.roleSubscription = this.sharedService.getCurrentRole().subscribe((role) => {
      if (role !== this.activeRole) {
        this.activeRole = role;
        localStorage.setItem('activeRole', role);
        this.loadUserRoles();
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkLayout(event.urlAfterRedirects);
      }
    });
    this.checkLayout(this.router.url);
  }

  ngOnDestroy(): void {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
    }
  }

  loadUserRoles(): void {
    const userRoles = this.sharedService.getUserRoles();
    this.roles = userRoles.map((role) => ({
      name: role.name,
      isActive: role.name === this.activeRole,
    }));
  }

  setDefaultRole(): void {
    const userRoles = this.sharedService.getUserRoles();
    const hasAdminRole = userRoles.some((role) => role.name === 'Admin');
    const hasParentRole = userRoles.some((role) => role.name === 'Parent');

    if (hasAdminRole) {
      this.activeRole = 'Admin';
    } else if (hasParentRole) {
      this.activeRole = 'Parent';
    }

    // Persist the active role
    localStorage.setItem('activeRole', this.activeRole);

    // Update the shared service and reload roles
    this.sharedService.setCurrentRole(this.activeRole);
    this.loadUserRoles();
  }

  hasAdminRole(): boolean {
    return this.roles.some((role) => role.name === 'Admin' && role.isActive);
  }

  hasParentRole(): boolean {
    return this.roles.some((role) => role.name === 'Parent' && role.isActive);
  }

  onDisplayChange(isDisplayed: boolean) {
    this.isDisplayedInLayout = isDisplayed;
  }

  checkLayout(currentRoute: string) {
    const adminPaymentReceipt = this.sharedService.buildRoleBasedUrlFor('Admin', 'paymentreceipt');
    const staffPaymentReceipt = this.sharedService.buildRoleBasedUrlFor('Staff', 'paymentreceipt');
    const parentPaymentReceipt = this.sharedService.buildRoleBasedUrlFor('Parent', 'paymentreceipt');
    this.hideLayout = currentRoute.includes(parentPaymentReceipt)
      || currentRoute.includes(adminPaymentReceipt)
      || currentRoute.includes(staffPaymentReceipt)
      || currentRoute.includes('/print/');
  }
}
